import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { actions } from '../../modules/Actions';

export interface ConsentInfoState {
  // 顧客ID
  customerId: number | undefined;
  // 情報更新の承諾情報
  isConsentedToInformationEdit: boolean;
  // パーミッションタイプ
  permissionType: string;
}

export const initialConsentInfoState: ConsentInfoState = {
  customerId: undefined,
  isConsentedToInformationEdit: false,
  permissionType: '',
};

export const ConsentInfoReducer = reducerWithInitialState(initialConsentInfoState)
  // 承諾情報更新
  .case(actions.updateConsentInfo, (_, payload: ConsentInfoState) => {
    return payload;
  });
